import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { has } from 'lodash-es';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';

import { ShouldUseErrorMessageFromDescription } from '../../typings/property-force-api';

@Injectable({
  providedIn: 'root'
})
export class ErrorMessageFromDescriptionInterceptor implements HttpInterceptor {
  intercept(request: HttpRequest<unknown>, next: HttpHandler) {
    let handledRequest: Observable<HttpEvent<unknown>>;

    if (request.context.get(ShouldUseErrorMessageFromDescription)) {
      handledRequest = next.handle(request).pipe(
        catchError((error) => {
          const hasError = has(error, 'error');

          if (hasError) {
            error.message = error.error.description ?? error.message;
          }

          return throwError(() => new Error(hasError ? error.message : error));
        })
      );
    } else {
      handledRequest = next.handle(request);
    }
    return handledRequest;
  }
}
